/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { numberDependencies } from './dependenciesNumber.generated';
import { createNumeric } from '../../factoriesAny.js';
export var numericDependencies = {
  bignumberDependencies: bignumberDependencies,
  fractionDependencies: fractionDependencies,
  numberDependencies: numberDependencies,
  createNumeric: createNumeric
};